import ModularAdoptionByCircle from 'assets/icons/modularByCircle.svg'

export default ModularAdoptionByCircle
